import React from "react";
import { FaChair, FaTable, FaCouch } from "react-icons/fa";
import barBanner from "../assets/banner2.jpg";

export default function Bar() {
  return (
    <div className="MainBodySection py-5" style={{ backgroundColor: "#f9f9f9" }}>
      <div className="container position-relative">
        {/* HEADER */}
        <div className="text-center mb-5">
          <h2 className="main-section-title text-primary">
            Bar & Restaurant Furniture
          </h2>
          <p className="text-muted fs-6">
            Durable, stylish, and comfortable furniture designed for commercial spaces.
          </p>
        </div>

        {/* BANNER IMAGE */}
        <div className="bg-light rounded shadow-sm mb-5 p-3">
          <img
            src={barBanner}
            alt="Bar & Restaurant Furniture"
            className="img-fluid rounded w-100"
            style={{ maxHeight: 420, objectFit: "cover" }}
          />
        </div>

        {/* SERVICE DESCRIPTION */}
        <div className="bg-white rounded shadow-sm p-4 mb-5">
          <p className="text-muted fs-6 mb-4">
            Kitchen Kings TZ designs and manufactures furniture specifically for bars and restaurants. Our products combine **durability, comfort, and style** to create welcoming environments that withstand high traffic and frequent use.
          </p>

          {/* KEY HIGHLIGHTS */}
          <ul className="list-unstyled mb-4">
            <li className="mb-3 d-flex align-items-start">
              <FaChair size={22} className="me-3 text-primary" />
              <span>Comfortable seating options including chairs and stools for patrons.</span>
            </li>
            <li className="mb-3 d-flex align-items-start">
              <FaTable size={22} className="me-3 text-primary" />
              <span>Durable tables suitable for high-traffic commercial use.</span>
            </li>
            <li className="mb-3 d-flex align-items-start">
              <FaCouch size={22} className="me-3 text-primary" />
              <span>Customizable furniture pieces to match your establishment’s theme and décor.</span>
            </li>
          </ul>

          {/* WORKFLOW / PROCESS */}
          <ol className="fs-6 mb-3">
            <li>Consult with clients to understand space, theme, and comfort requirements.</li>
            <li>Select materials and finishes suitable for heavy commercial use.</li>
            <li>Manufacture furniture with a focus on durability, comfort, and style.</li>
            <li>Deliver and install furniture with attention to placement and aesthetics.</li>
          </ol>

          <p className="text-muted fs-6 mt-3">
            Our furniture ensures your bar or restaurant is <strong>both stylish and practical</strong>, providing an excellent experience for customers while maintaining longevity in demanding commercial environments.
          </p>
        </div>
      </div>
    </div>
  );
}
